'use client'

import {useLayoutStore} from '@/src/shared/ui/layout'
import {observer} from 'mobx-react'
import {SessionRequirementsService} from '@/src/features/requirement-session-fields/presentation/service'
import {PersonalForm, PersonalFormSchema} from '@/src/features/personal-form'
import {FormProvider} from '@/src/shared/modules/form'
import {useFormContext} from 'react-hook-form'
import {useEffect} from 'react'

export const RequirementSessionFieldsProvider = observer(({children}: React.PropsWithChildren) => {
  const layoutStore = useLayoutStore()

  return (
    (layoutStore.data.session?.user && (
      <SessionRequirementsService
        profileForm={
          <FormProvider data={layoutStore.data.session.user} schema={PersonalFormSchema}>
            <PersonalForm simple />
            <TriggerFormValidate />
          </FormProvider>
        }>
        {children}
      </SessionRequirementsService>
    )) ||
    children
  )
})

const TriggerFormValidate = () => {
  const form = useFormContext()

  useEffect(() => {
    if (form) {
      form.trigger()
    }
  }, [form])

  return <></>
}
